
import React from "react"
import { render } from "react-dom"
import createBrowserHistory from "history/createBrowserHistory"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import registerServiceWorker from "./registerServiceWorker"
import './styles/bootstrap.min.css';
import './styles/react-bootstrap-table.min.css';
import './styles/App.css';
import './styles/usbc.css';
import './web.config';
import './config.js';

const history = createBrowserHistory()

render(
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>,
  document.getElementById("root"),
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js